"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthResponseSchema = exports.TelegramAuthRequestSchema = exports.UserProfileSchema = exports.PublicIdSchema = exports.ProvisioningStatusSchema = exports.UserStatusSchema = void 0;
const zod_1 = require("zod");
const invite_token_1 = require("../invite-token");
const locale_1 = require("../locale");
const public_id_1 = require("../public-id");
exports.UserStatusSchema = zod_1.z.enum(['started', 'email_pending', 'active', 'blocked', 'merged']);
exports.ProvisioningStatusSchema = zod_1.z.enum([
    'not_started',
    'pending',
    'running',
    'ready',
    'failed',
]);
/** Generated (nine digits) or imported (any token up to 32 chars, no whitespace); text in the database. */
exports.PublicIdSchema = zod_1.z.string().min(1).max(public_id_1.PUBLIC_ID_MAX_LENGTH).regex(public_id_1.PUBLIC_ID_TOKEN);
exports.UserProfileSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    publicId: exports.PublicIdSchema,
    status: exports.UserStatusSchema,
    locale: zod_1.z.enum(locale_1.LOCALES),
    emailMasked: zod_1.z.string().nullable(),
    provisioningStatus: exports.ProvisioningStatusSchema,
    /** Manual time zone (IANA id); null means "automatic". */
    timezone: zod_1.z.string().nullable(),
    /** Last zone the Mini App reported for the device. */
    deviceTimezone: zod_1.z.string().nullable(),
    /** Payout details remembered from the last exchange; null until the first one. */
    legalFirstName: zod_1.z.string().nullable(),
    legalLastName: zod_1.z.string().nullable(),
    phone: zod_1.z.string().nullable(),
    /** True when a PIN is set; the Mini App then starts locked after every login. */
    pinEnabled: zod_1.z.boolean(),
});
exports.TelegramAuthRequestSchema = zod_1.z.object({
    initData: zod_1.z.string().min(1).max(4096),
    /** Size-checked only; the service validates it with `isTimezone` and ignores what it does not know. */
    deviceTimezone: zod_1.z.string().max(64).optional(),
    /** Invite token from the "Open wallet" button URL (spec 2026-10-22 §5); pre-fills the email. */
    inviteToken: invite_token_1.InviteTokenSchema.optional(),
});
exports.AuthResponseSchema = zod_1.z.object({
    accessToken: zod_1.z.string(),
    expiresIn: zod_1.z.number().int().positive(),
    user: exports.UserProfileSchema,
    /** Email of the pending allowlist entry whose invite token arrived as `inviteToken` in the login body; null otherwise. */
    inviteEmail: zod_1.z.string().nullable(),
    /** The bot's Telegram username, for support deep links (spec 2026-10-28 §5.6). Empty when `getMe` failed at login. */
    botUsername: zod_1.z.string(),
    /** `pin.resume_lock_seconds`: background pause after which the Mini App asks for the PIN again. */
    pinResumeLockSeconds: zod_1.z.number().int().min(0),
});
//# sourceMappingURL=auth.js.map